import { render, staticRenderFns } from "./BankAccountDetail.vue?vue&type=template&id=1661e4d5&scoped=true&"
import script from "./BankAccountDetail.vue?vue&type=script&lang=js&"
export * from "./BankAccountDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1661e4d5",
  null
  
)

export default component.exports